import React from "react";
import Accordion from "components/accordion";
import Newsletter from "components/newsletter";
import { DesktopFooterLinks, FooterLinks, FooterSocial } from "./details";
import FooterCopyright from "./copyright";
import useIsMobile from "../../hooks/useIsMobile";

const Footer = ({ data: { links, logo, newsletter, contact, paymentIcons, social } }) => {
    const isMobile = useIsMobile();

    return (
        <footer className="footer w-full">
            <div className="site-footer lg:pt-14 px-0 lg:pb-2.5 w-full bg-blue-700 text-white xsm:py-10 pt-8 pb-2.5">
                <div className="container mx-auto px-4 lg:px-0">
                    <div className="flex flex-row flex-wrap lg:flex-nowrap justify-center lg:justify-start -mx-4 md:mx-0 lg:-mt-2.5">
                        <FooterSocial logo={logo} social={social} />
                        <FooterLinks data={links} />
                        <DesktopFooterLinks data={links} />
                        {isMobile ? (
                            <Accordion heading={newsletter?.heading} className="footer-item lg:hidden block lg:py-0 py-2.5 px-4 lg:px-0" arrowFill="white">
                                <Newsletter data={newsletter} contact={contact} />
                            </Accordion>
                        ) : (
                            <div className="footer-item lg:block hidden lg:py-0 py-2.5 px-4 lg:px-0">
                                <Newsletter data={newsletter} contact={contact} />
                            </div>
                        )}

                    </div>
                </div>
            </div>
            <FooterCopyright data={paymentIcons} />
        </footer>
    );
};

export default Footer;
